module.exports = __webpack_public_path__ + "img/de.93291707.svg";